import React, { useState } from 'react';
import emailjs from "@emailjs/browser";

const Events = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    eventType: '',
    date: '',
    guests: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs.send(
      "service_esfde0h",
      "template_i3nkbg9",
      {
        ...formData,
        type: "Événement",
        subject: "" //  pour éviter conflit avec contact
      },
      "ENl3SMxqF8Dvo9m6N"
    )
    .then(() => {
      alert("Demande envoyée avec succès ! 📩");

      setFormData({
        name: '',
        email: '',
        phone: '',
        eventType: '',
        date: '',
        guests: '',
        message: ''
      });
    })
    .catch((error) => {
      console.error(error);
      alert("Erreur lors de l'envoi ❌");
    });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const eventTypes = [
    'Mariage',
    'Anniversaire',
    'Événement d\'entreprise',
    'Baby shower',
    'Baptême',
    'Cérémonie',
    'Autre'
  ];

  return (
    <div>
      <section className="bg-gradient-to-r from-accent to-primary text-white section-padding">
        <div className="container-custom text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Événements Privés</h1>
          <p className="text-xl opacity-90">
            Créons ensemble des moments inoubliables
          </p>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom">

          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-primary mb-4">Nos Services Événementiels</h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {[
              { icon: 'fas fa-heart', title: 'Mariages' },
              { icon: 'fas fa-birthday-cake', title: 'Anniversaires' },
              { icon: 'fas fa-briefcase', title: 'Événements Professionnels' }
            ].map((service, index) => (
              <div key={index} className="bg-secondary p-8 rounded-2xl text-center">
                <div className="w-20 h-20 bg-primary rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${service.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold">{service.title}</h3>
              </div>
            ))}
          </div>

          <div className="bg-secondary rounded-3xl p-8">
            <div className="max-w-2xl mx-auto">

              <h2 className="text-3xl font-bold text-primary mb-6 text-center">
                Demander un devis
              </h2>

              <form onSubmit={handleSubmit} className="space-y-6">

                <input name="name" value={formData.name} onChange={handleChange} required placeholder="Nom complet" className="w-full px-4 py-3 border rounded-lg" />

                <input name="email" type="email" value={formData.email} onChange={handleChange} required placeholder="Email" className="w-full px-4 py-3 border rounded-lg" />

                <input name="phone" value={formData.phone} onChange={handleChange} required placeholder="Téléphone" className="w-full px-4 py-3 border rounded-lg" />

                <select name="eventType" value={formData.eventType} onChange={handleChange} required className="w-full px-4 py-3 border rounded-lg">
                  <option value="">Type d'événement</option>
                  {eventTypes.map(type => <option key={type}>{type}</option>)}
                </select>

                <input type="date" name="date" value={formData.date} onChange={handleChange} className="w-full px-4 py-3 border rounded-lg" />

                <textarea name="message" value={formData.message} onChange={handleChange} required rows="5" placeholder="Votre demande..." className="w-full px-4 py-3 border rounded-lg"></textarea>

                <button type="submit" className="btn-primary w-full py-4">
                  Envoyer la demande
                </button>

              </form>

            </div>
          </div>

        </div>
      </section>
    </div>
  );
};

export default Events;